<template>
  <TnLink class="margin-top-l" arrow-left :text="text" @click="router.back()" />
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { TnLink } from '@telenornorgeinternal/telegrafen-vue3-core';

defineProps<{ text: string }>();

// TnLink's arrowLeft prop replaces the chevron_left.svg image.
// TnLink already renders as `inline-flex` with centred items, which aligns the
// arrow with the label - don't override its `display`.
const router = useRouter();
</script>
